export default __webpack_public_path__ + "static/media/phone.7aadff4a.png";